import Dispatch from '../core/Dispatch';
import { COMPONENT_INIT } from '../lib/events';
import Pattern from '../lib/Pattern';

export default el => {

    let patternInstance;

    const init = () => {
        patternInstance = Pattern(el.querySelector('[data-pattern]'));

        Dispatch.emit(COMPONENT_INIT);
    };

    const destroy = () => {
        patternInstance.destroy();
    };

    return {
        init,
        destroy
    };

};
